import { Div, Collection, Button, $ } from "@tblabs/truffle";
import { Field } from "../../Models/Description/Field";
import { NormalizeUrl } from "./NormalizeUrl";


export class DescriptionTabs extends Div
{
    constructor(collection: Collection<Field>)
    {
        super("product-info__tabs-scroll");

        this.Append(
            new Div("tabs__list product-info__tabs-list").Append(
                ...collection.Items
                    .filter(entry => entry.Visible.value)
                    .map(entry =>
                    {
                        return new Button(entry.Header.value).Class("tabs__trigger product-info__tab-trigger")
                            .Style("white-space: nowrap;")
                            .OnClick(() =>
                            {
                                const id = NormalizeUrl.Normalize(entry.Header.value);
                                const element = $("#" + id);
                                if (element)
                                {
                                    element.scrollIntoView({ behavior: "smooth" });
                                }
                            });
                    }),
            ),
        );
    }
}
